module.exports = __webpack_public_path__ + "static/media/champ_blue.98b55c7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/champ_blue.svg
// module id = ./src/assets/media/forum/champ_blue.svg
// module chunks = 16